module.exports = __webpack_public_path__ + "static/media/frontend-dev.73839389.jpg";